import React, { useEffect, useState } from 'react'
import {
  Table,
  Popup,
  Icon,
  Segment,
  Divider,
  Form,
  Modal,
  Header,
  Button,
  Grid,
  Input,
  PopupContent,
  List,
} from 'semantic-ui-react'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import { formatTotalPrice } from '../../../lib/utils/utils'
import env from '../../../env'
import './AdminOrder.css'
import BuyerOrderMap from '../../buyer/Orders/BuyerOrderMap'
import { useNavigate, useParams } from 'react-router-dom'
import PizzaTracker from '../../shared/PizzaTracker/PizzaTracker'
import ConfirmationModal from '../../../components/ConfirmationModal'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import _ from 'underscore'
import AdminOrderFulfillmentRow from './AdminOrderFulfilmentRow'
import OrderItemDetailTwo from '../../../components/OrderItemDetail/OrderItemDetailTwo'
import MickeyButton from '../../../components/MickeyButton/MickeyButton'
import MickeyDropdown from '../../../components/MickeyDropdown/MickeyDropdown'
import { toast } from 'react-toastify'
import useAxios from '../../../lib/auth/useAxios'
import { ExclamationTriangle } from 'react-bootstrap-icons'
import { hasPermission } from '../../../lib/utils/utils'
import { useDispatch, useSelector } from 'react-redux'
import AdminOrderRFQsRow from './AdminOrderRFQsRow'
import {
  CaretDown,
  CaretRight,
  Checks,
  PaperPlaneTilt,
  Plus,
  Files,
  Trash,
  TrashSimple,
  Truck,
} from 'phosphor-react'
import MickeyPlaceholderLoading from '../../../components/PlaceholderLoading/PlaceholderLoading'

function AdminOrderRFQs(props) {
  const axios = useAxios()
  const user = useSelector((state) => state.user.user)
  const navigate = useNavigate()
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const canUpdate = hasPermission(user, 'Update Fulfillment')
  const canDelete = hasPermission(user, 'Delete Fulfillment')
  const { order, reloadAdminOrder, setReloadAdminOrder } = props

  const [rfqs, setRfqs] = useState([])
  const [itemsHeaderRow, setItemsHeaderRow] = useState(['Product', 'Quantity'])
  const [selected, setSelected] = useState([])

  useEffect(() => {
    let tempItemsHeaderRow = ['Product', 'Quantity', 'Buyer Price']
    const supplierNames = new Set()

    rfqs.forEach((rfq) => {
      rfq.rfq_items.forEach((rfqItem) => {
        if (rfqItem?.rfq?.supplier?.business?.name) {
          supplierNames.add(rfqItem?.rfq?.supplier?.business?.name)
        }
      })
    })

    // Convert to array and sort alphabetically
    const sortedSupplierNames = Array.from(supplierNames).sort()
    tempItemsHeaderRow.push(...sortedSupplierNames)

    setItemsHeaderRow(tempItemsHeaderRow)
    return () => {}
  }, [rfqs])

  async function acceptRFQPrices() {
    try {
      await axios.post('/main/admin-rfqs/', {
        selected: selected,
      })
      toast.success('Prices accepted successfully')

      navigate(`/portal/admin/deals/${order?.string_token}/materials-list`)
    } catch (error) {
      toast.error('Failed to accept prices')
      console.error('Error accepting prices:', error)
    }
  }

  return (
    <>
      <div>
        {!order?.id && <MickeyPlaceholderLoading />}
        {order?.id && (
          <MickeyTable
            headerRow={itemsHeaderRow}
            setParentRow={setRfqs}
            containerClassName={'rfq-table'}
            loadedStyle={{ width: '100%' }}
            basicSegment
            url={'/main/admin-rfqs/'}
            urlParams={{
              order_id: order?.id,
            }}
            // reload={reloadAdminOrder}
            // setReload={setReloadAdminOrder}
            renderBodyRow={(data, index) => {
              return (
                <AdminOrderRFQsRow
                  rfqs={rfqs}
                  order={order}
                  rfq={data}
                  index={index}
                  selected={selected}
                  setSelected={setSelected}
                />
              )
            }}
            emptyIconHtml={<Files size={40} />}
            emptyMessage={
              'RFQs will populate here. To create a new RFQ go to the Material List, select the materials in the RFQ with the checkboxes, and click Send Document > RFQ. Then select the suppliers you want to send to.'
            }
            footerRow={
              <Table.Row>
                <Table.HeaderCell
                  colSpan={itemsHeaderRow?.length - 1}
                ></Table.HeaderCell>
                <Table.HeaderCell>
                  <Button
                    icon={<Plus weight="bold" />}
                    primary
                    style={{
                      '--primaryColor': tenant?.deployment_primary_color,
                      '--secondaryButtonColor':
                        env.REACT_APP_SECONDARY_BUTTON_COLOR,
                    }}
                    onClick={() => acceptRFQPrices()}
                  >
                    Accept {selected?.length} Prices
                  </Button>
                </Table.HeaderCell>
              </Table.Row>
            }
          />
        )}
      </div>
    </>
  )
}

export default AdminOrderRFQs
